import '../helpers/svgContainsPolyfill';

let mobileMyAccountLink = document.getElementById('mobile-my-account-link');
let mobileMyAccountMenu = document.getElementById('mobile-my-account-menu');
let mobileMyAccountClose = document.getElementById('mobile-my-account-close');

const OPEN_CLASS = "open";
const ACTIVE_CLASS = "active";

export function mobileNav() {
    // open/close global nav
    var mobileHeader = document.getElementsByClassName('mobile-header')[0];
    var mobileNavTrigger = document.getElementsByClassName('mobile-header-top-trigger')[0];

    if (mobileHeader === undefined || mobileNavTrigger === undefined) {
        return;
    }

    var toggleActive = function () {
        mobileHeader.classList.toggle(ACTIVE_CLASS);
    }

    mobileNavTrigger.addEventListener('click', toggleActive);

    // open/close search
    var mobileSearch = document.getElementsByClassName('mobile-search-wrapper')[0];
    var searchTrigger = document.getElementsByClassName('utility-nav-search')[0];

    var toggleSearchActive = function () {
        mobileSearch.classList.toggle(ACTIVE_CLASS);
        searchTrigger.classList.toggle(ACTIVE_CLASS);
        if (mobileMyAccountMenu.classList.contains(OPEN_CLASS)) {
            closeMobileMyAccountMenu();
        }
    }

    if (mobileMyAccountLink)
        mobileMyAccountLink.addEventListener('click', toggleMobileMyAccountMenu);
    if (mobileMyAccountClose)
        mobileMyAccountClose.addEventListener('click', toggleMobileMyAccountMenu);

    searchTrigger.addEventListener('click', toggleSearchActive);
    mobileSearch.addEventListener('blur', toggleSearchActive);

    // Close mobile search on outside click
    document.addEventListener('click', function (e) {
        if (!searchTrigger.contains(e.target as any) && !mobileSearch.contains(e.target as any)) {
            mobileSearch.classList.remove(ACTIVE_CLASS);
            searchTrigger.classList.remove(ACTIVE_CLASS);
        }

        if (!mobileMyAccountLink.contains(e.target as any) && mobileMyAccountMenu.classList.contains(OPEN_CLASS)) {
            closeMobileMyAccountMenu();
        }
    });
}

function closeMobileMyAccountMenu() {
    mobileMyAccountMenu.classList.remove(OPEN_CLASS);
    mobileMyAccountClose.style.display = "none";
    mobileMyAccountLink.style.display = "block";
}

function openMobileMyAccountMenu() {
    mobileMyAccountMenu.classList.add(OPEN_CLASS);
    mobileMyAccountClose.style.display = "block";
    mobileMyAccountLink.style.display = "none";
}

function toggleMobileMyAccountMenu() {
    if (mobileMyAccountMenu) {
        if (mobileMyAccountMenu.classList.contains(OPEN_CLASS)) {
            closeMobileMyAccountMenu();
        }
        else {
            openMobileMyAccountMenu();
        }
    }

}